import React from 'react';
import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import styles from './AboutOwnerMini.scss';
import { SkeletonProps } from '../../interfaces/SkeletonProps';
import Refresh from '../Refresh/Refresh';

const AboutOwnerMiniSkeleton: React.FunctionComponent<SkeletonProps> = ({
  animated,
  onRefresh,
  displayRefreshButton,
}) => (
  <Refresh
    onRefresh={onRefresh}
    className={styles.aboutOwnerMini}
    displayRefreshButton={displayRefreshButton}
  >
    <PlaceholderBar
      animated={animated}
      height={98}
      width={98}
      marginRight={24}
    />
    <div className="jg-flex-g1">
      <PlaceholderBar
        animated={animated}
        height={24}
        width="90%"
        colour="nobel"
      />
      <PlaceholderBar animated={animated} height={19} width="80%" />
    </div>
  </Refresh>
);

export default AboutOwnerMiniSkeleton;
